"use client";

import { useCallback } from "react";
import debounce from "lodash/debounce";

// layouts
import SinglePageLayout from "@/layouts/SinglePageLayout";

// components
import SearchResultsControls from "../components/SearchResultsControls";
import SearchFilters from "@/components/SearchComponents/SearchFilters";
import LocationCard from "@/components/LocationCard";

// helpers
import {
  DEFAULT_SEARCH_PARAMS,
  transformSearchParams,
} from "../helpers";
import useQueryParams from "@/hooks/useQueryParams";
import { buildQueryString } from "@/helpers/searchHelpers";

// interfaces
import { IBuildQueryString } from "@/types/helpers/searchHelpers";

// assets
import styles from "@/assets/styles/pages/search-results.module.scss";


const SearchResultsPageLoading = () => {

  const [params, setQueryParams] = useQueryParams<{ [key: string]: string | null; }>({
    ...DEFAULT_SEARCH_PARAMS,
  });

  const transformedSearchParams = transformSearchParams(params);


  const debouncedSetQuery = useCallback(debounce(payload => setQueryParams(payload), 1000), []);

  const onFiltersChange = (key: string, value: unknown) => {
    const updatedSearchParams = { ...transformedSearchParams, [key]: value };

    if (key === "size__in") {
      updatedSearchParams.sizeCustom = null;
    }

    const queryParamsPayload = buildQueryString(updatedSearchParams as IBuildQueryString).object;

    if (key === "sizeCustom") {
      debouncedSetQuery(queryParamsPayload);

      return;
    }

    setQueryParams(queryParamsPayload);
  };

  return (
    <SinglePageLayout className={styles["locl-search-results"]}>
      <h1 className={styles["locl-search-results__hidden-title"]}>Search results</h1>
      <div className={styles["locl-search-results__filter_wrap"]}>
        <SearchFilters
          value={transformedSearchParams}
          onChange={onFiltersChange}
          showSearch={false}
          onSearch={() => ({})}
          onMoreFilters={() => ({})}
          isShowSearchTabs
        />
      </div>
      <h3 className={styles["locl-search-results__cards__title"]}>Locations</h3>
      <SearchResultsControls
        isAuthorized={false}
        showMap={false}
        toggleMapView={() => ({})}
      />
      <div className={styles["locl-search-results__cards"]}>
        <div className={styles["locl-search-results__cards__wrapper"]}>
          <div className={styles["locl-search-results__cards__wrapper__item"]} data-testid="locl-search-results-wrapper">
            { Array.from({ length: 8 }).fill(null).map((_, index) => <LocationCard.Loading key={index}/>) }
          </div>
        </div>
      </div>
    </SinglePageLayout>
  )
}

export default SearchResultsPageLoading;
